import { empApi } from "./client";

// ============ Chấm công ngoài (register outside) ============
// body: { employeeId, checkinPlace, comment, confirmImage: string[], workingDayRate? }
export const createRegisterOutsideApi = (body) =>
  empApi.post("/registerCheckIn/app/add", body);

export const getRegisterOutsideListApi = (params) =>
  empApi.get("/registerCheckIn/app/user", params);

export const getRegisterOutsideByIdApi = (id) =>
  empApi.get(`/registerCheckIn/app/detail/${id}`);

// ============ Làm bù (make-up work) ============
// body: { images: string[], dayLeave, note }
export const createMakeupWorkApi = (body) =>
  empApi.post("/makeupWorkRequest/app", body);

export const getMakeupWorkListApi = (params) =>
  empApi.get("/makeupWorkRequest/app", params);

export const getMakeupWorkByIdApi = (id) =>
  empApi.get(`/makeupWorkRequest/app/${id}`);

export const deleteMakeupWorkApi = (id) =>
  empApi.del(`/makeupWorkRequest/app/${id}`);
